module.exports = __webpack_public_path__ + "media/images/color-cb9749b8f42f464fea34abef1f25f950.svg";